export * from './date';
export * from './number';
export * from './select';
export * from './semantic';
export * from './tag';
export * from './text';
export * from './textarea';

import date from './date';
import number from './number';
import select from './select';
import semantic from './semantic';
import tag from './tag';
import text from './text';
import textarea from './textarea';

import {AttributeType} from '../constants';

export default {
	[AttributeType.DATE]: date,
	[AttributeType.NUMBER]: number,
	[AttributeType.SELECT]: select,
	[AttributeType.SEMANTIC]: semantic,
	[AttributeType.TAG]: tag,
	[AttributeType.TEXT]: text,
	[AttributeType.TEXTAREA]: textarea,
};
